import request from "@/utils/request";
import { client_secret, client_id, grant_type } from "@/config/auth";

export function loginByEmail(username, password) {
  const data = {
    email: username,
    password,
    client_id,
    client_secret,
    grant_type
  };
  return request({
    url: "/api/admin/signin",
    method: "post",
    data
  });
}

export function logout() {
  return request({
    url: "/api/logout",
    method: "post"
  });
}

export function getUserInfo() {
  return request({
    url: "api/profile/user",
    method: "get"
  });
}
